import { observable, action, computed } from 'mobx'
import { Card, Employee, CreditsSummary } from '@odiupsk/up-api-client'
import { employeesApi, holderAccountsApi } from '../../common/api'
import { logError } from '../../common/api/utils'

/**
 * Store for dashboard page, mostly for handling cards
 */
export class CardsStore {
  @observable cards: Card[] = []

  @observable cardCreditsSummary?: CreditsSummary

  @observable selectedCardId?: Card['id']

  @observable employee: Employee

  constructor(employee: Employee) {
    this.employee = employee
  }

  @action async fetchEmpoyeeCards() {
    const response = await employeesApi.getEmployeeCards(this.employee.id)
    this.cards = response.data.data!
  }

  /**
   * set selected card id - if not provided, tries to set id of first fetched card if exists
   * @param cardId
   */
  @action setSelectedCardId(cardId?: Card['id']) {
    let selectedCardId

    if (!cardId) {
      if (this.cards.length > 0) {
        selectedCardId = this.cards[0].id
      }
    } else {
      selectedCardId = cardId
    }

    this.selectedCardId = selectedCardId
    this.fetchCreditExpirationsForSelectedCard()
  }

  @action async fetchCreditExpirationsForSelectedCard(accountId?: string) {
    if (!this.selectedCardId) return

    const holderAccountId = this.selectedCardId ? this.cards[0].holder_account_id! : accountId!

    try {
      const { data } = await holderAccountsApi.getHolderAccountCreditsSummary(holderAccountId!)
      return data
    } catch (err) {
      logError(err)
      return {}
    }
  }

  @computed get selectedCard() {
    return this.cards.find(card => card.id === this.selectedCardId)
  }
}
